import React, { Fragment, useEffect, useState } from "react";
import cx from "classnames";

type Props = {
  isHidden: boolean;
  password: string;
  passwordConfirm: string;
  isValidPasswordHandler?: Function;
} & React.ButtonHTMLAttributes<HTMLInputElement>;

const ValidationPassword: React.FC<Props> = ({
  isHidden,
  password,
  passwordConfirm,
  className,
  isValidPasswordHandler,
}): JSX.Element => {
  const [isValidMin8Characters, setIsValidMin8Characters] =
    useState<boolean>(false);
  const [isValidCharacters, setIsValidCharacters] = useState<boolean>(false);
  const [isValidSamePassword, setIsValidSamePassword] =
    useState<boolean>(false);

  useEffect(() => {
    const validMin8Characters = (password: string): boolean => {
      if (password.trim() === "") return false;
      return password.length >= 8;
    };

    const validNumericLetters = (password: string): boolean => {
      if (password.trim() === "") return false;
      if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/.test(password)) return false;
      return true;
    };

    const validSamePassword = (password: string, confirm: string): boolean => {
      if (password.trim() === "" && confirm.trim() === "") return true;
      if (password !== confirm) return false;
      return true;
    };

    const isValidMin8Characters = validMin8Characters(password);
    const isValidCharacters = validNumericLetters(password);
    const isValidSamePassword = validSamePassword(password, passwordConfirm);

    setIsValidMin8Characters(isValidMin8Characters);
    setIsValidCharacters(isValidCharacters);
    setIsValidSamePassword(isValidSamePassword);

    isValidPasswordHandler &&
      isValidPasswordHandler(
        isValidMin8Characters && isValidCharacters && isValidSamePassword
      );
  }, [password, passwordConfirm, isValidPasswordHandler]);

  return (
    <Fragment>
      {!isHidden && (
        <Fragment>
          <span
            className={cx(
              "font-nunito mt-1 text-xs",
              !isValidMin8Characters ? "text-bt-red" : "text-bt-green"
            )}
          >
            <div className={cx("flex flex-row", className)}>
              <span className="px-2">
                It must contain at least 8 characters
              </span>
            </div>
          </span>

          <span
            className={cx(
              "font-nunito mt-1 text-xs",
              !isValidCharacters ? "text-bt-red" : "text-bt-green"
            )}
          >
            <div className={cx("flex flex-row", className)}>
              <span className="px-2">
                It must contain upper/lower case and numbers
              </span>
            </div>
          </span>

          <span
            className={cx(
              "font-nunito mt-1 text-xs",
              !isValidSamePassword ? "text-bt-red" : "text-bt-green"
            )}
          >
            <div className={cx("flex flex-row", className)}>
              <span className="px-2">Passwords cannot be different</span>
            </div>
          </span>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ValidationPassword;
